import { FlexContainer } from '@reapit/elements'
import { LoadingSkeleton } from '@reapitform/common-ui'
import React from 'react'

const PaymentMethodsDisplayViewLoading: React.FC = () => {
  return (
    <FlexContainer isFlexColumn>
      <LoadingSkeleton height="1.25rem" width="50%" />
      <LoadingSkeleton height="1.25rem" />
      <LoadingSkeleton height="1.25rem" />
      <LoadingSkeleton height="1.25rem" />
    </FlexContainer>
  )
}

export default PaymentMethodsDisplayViewLoading
